import * as _ from "lodash-es";
import React, { Component, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import ILoadDashboardDTO from "../../../models/DTO/ILoadDashboardDTO";
import ILoadUserDTO from "../../../models/DTO/ILoadUserDTO";
import IOnUpdateSupplierIntegrationsDTO from "../../../models/DTO/IOnUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import UIService from "../../../services/UIService";
import UserService from "../../../services/UserService";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import { OwAccordion } from "../../shared/OwAccordion/OwAccordion";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import AmazonConnect from "./AmazonConnect/AmazonConnect";
import { EbayConnect } from "./EbayConnect/EbayConnect";
import FishbowlConnect from "./FishbowlConnect/FishbowlConnect";
import GoogleConnect from "./GoogleConnect/GoogleConnect";
import { HubspotConnect } from "./HubspotConnect/HubspotConnect";
import OpenCartConnect from "./OpenCartConnect/OpenCartConnect";
import QuickbooksDesktopConnect from "./QuickbooksDesktopConnect/QuickbooksDesktopConnect";
import ShipstationConnect from "./ShipstationConnect/ShipstationConnect";
import ShopifyConnect from "./ShopifyConnect/ShopifyConnect";
import SlackConnect from "./SlackConnect/SlackConnect";
import SquareConnect from "./SquareConnect/SquareConnect";

import quickbooksLogo from "../../../assets/images/quickbooks/QuickBooks Logo_Horz_Rev.png";
import shipstationLogo from "../../../assets/images/shipstation/shipstation-logo-white.png";
import shipstationWrenchIcon from "../../../assets/images/shipstation/wrench-icon.png";
import QuickbooksConnect from "./QuickbooksConnect/QuickbooksConnect";
import IQBOSetDefaultPOFieldDTO from "../../../models/DTO/IQBOSetDefaultPOFieldDTO";
import IQBOSetDefaultSalesTermDTO from "../../../models/DTO/IQBOSetDefaultSalesTermDTO";
import TaxJarConnect from "./TaxJarConnect/TaxJarConnect";
import NYSLAConnect from "./NYSLAConnect/NYSLAConnect";
import WooCommerceConnect from "./WooCommerceConnect/WooCommerceConnect";
import { XeroConnect } from "./XeroConnect/XeroConnect";
import ZapierConnect from "./ZapierConnect/ZapierConnect";
import ZohoConnect from "./ZohoConnect/ZohoConnect";
import "./BusinessIntegrations.scss";
import { WayfairConnect } from "./WayfairConnect/WayfairConnect";
import { SpsCommerceConnect } from "./SpsCommerceConnect/SpsCommerceConnect";
import { StripeConnect } from "./StripeConnect/StripeConnect";
import { ZoeyConnect } from "./ZoeyConnect/ZoeyConnect";
import ICatalog from "../../../models/ICatalog";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import { BigCommerceConnect } from "./BigCommerceConnect/BigCommerceConnect";
import { Socket } from "socket.io-client";
import { VistaTracConnect } from "./VistaTracConnect/VistaTracConnect";
import { ChRobinsonConnect } from "./ChRobinsonConnect/ChRobinsonConnect";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { AuthorizeNetConnect } from "./AuthorizeNetConnect/AuthorizeNetConnect";
import { QuickbooksDesktopIntegration } from "./QuickbooksDesktopIntegration/QuickbooksDesktopIntegration";
import { QuickbooksConnectWrapper } from "./QuickbooksConnect/QuickbooksConnectWrapper";
import { FastBoundConnect } from "./FastBoundConnect/FastBoundConnect";
import WineService from "../../../services/WineService";
import { UnanetConnect } from "@components/business/BusinessIntegrations/UnanetConnect/UnanetConnect";
import IndustryNameEnum from "@models/IndustryNameEnum";

type Props = {};

export const BusinessIntegrations = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const isMainViewLight = UIService.isMainViewLight();

    const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumbs[]>([
        { title: "Dashboard", url: "/dashboard" },
        { title: "Business Integrations", url: "/business/integrations" },
    ]);
    const [catalogs, setCatalogs] = useState<ICatalog[]>([]);

    const onUpdateSupplierIntegrations = (data: IOnUpdateSupplierIntegrationsDTO) => {
        loadData();
    };

    const onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        setCatalogs(data.catalogs);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: onGetCatalogs },
        { endpoint: EndpointsEnum.SupplierOnUpdateSupplierIntegrations, fn: onUpdateSupplierIntegrations },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getCatalogs();

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const loadData = () => {
        const payload: ILoadUserDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
        };

        socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    const getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            callMeta: {
                view: "BusinessIntegrations",
                fn: "getCatalogs",
            },
        };

        socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    const updateSupplierModel = (_supplierModel: ISupplierModel) => {
        // Do nothing?
    };

    const handleChange = (e: any) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        // setState(state);
    };

    return (
        <div className="BusinessIntegrations">
            {/*<Breadcrumbs navItems={breadcrumbs} />*/}

            <div className="row mt-2">
                <div className={"col-12"}>
                    <OwTitle title={"business_integrations"} leftIconName={"fad fa-exchange-alt"} />
                </div>
            </div>

            <div
                className={
                    " mb-5 " + (userModel?.isSupplierUser && userModel?.userType && userModel?.userType.name === "ADMIN" ? "" : "d-none")
                }>
                <div className={""}>
                    <div className={"row mt-4"}>
                        <OwTitle title={"accounting"} />
                    </div>

                    <div className={"row mb-2"}>
                        <QuickbooksConnectWrapper catalogs={catalogs} />
                    </div>

                    <div className={"row mb-2"}>
                        <QuickbooksDesktopIntegration />
                    </div>

                    <div className={"row mb-2"}>
                        <XeroConnect socket={socket} />
                    </div>

                    <div className={"row mb-2"}>
                        <TaxJarConnect
                            supplierModel={supplierModel}
                            userModel={userModel}
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                            isMainViewLight={isMainViewLight}
                        />
                    </div>

                    <div className={"row mt-4"}>
                        <OwTitle title={"payments"} />
                    </div>

                    <div className={"row mb-2"}>
                        <StripeConnect
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                            isMainViewLight={isMainViewLight}
                        />
                    </div>

                    <div className={"row mb-2"}>
                        <SquareConnect updateSupplierModelFn={updateSupplierModel} />
                    </div>

                    <div className="row mb-2">
                        <AuthorizeNetConnect />
                    </div>

                    <div className={"row mt-4"}>
                        <OwTitle title={"erp"} />
                    </div>

                    <div className={"row mb-2"}>
                        <UnanetConnect />
                    </div>

                    <div className={"row mt-4"}>
                        <OwTitle title={"ecommerce"} />
                    </div>

                    <div className={"row mb-2"}>
                        <ShopifyConnect
                            supplierModel={supplierModel}
                            userModel={userModel}
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                            isMainViewLight={isMainViewLight}
                        />
                    </div>

                    <div className={"row mb-2"}>
                        <WooCommerceConnect />
                    </div>

                    {/* <div className={"row mb-2"}>
                        <OpenCartConnect
                            supplierModel={supplierModel}
                            userModel={userModel}
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                        />
                    </div> */}

                    {/*<div className={"row mb-2"}>*/}
                    {/*    <AmazonConnect userModel={userModel} supplierModel={supplierModel} socket={socket} notifyFn={uiContext.notifyFn} />*/}
                    {/*</div>*/}

                    <div className={"row mb-2"}>
                        <SpsCommerceConnect socket={socket} notifyFn={uiContext.notifyFn} />
                    </div>

                    <div className={"row mb-2"}>
                        <WayfairConnect socket={socket} notifyFn={uiContext.notifyFn} />
                    </div>

                    {/*<div className={"row mb-2"}>*/}
                    {/*    <EbayConnect />*/}
                    {/*</div>*/}

                    <div className={"row mb-2"}>
                        <BigCommerceConnect
                            setActivityIndicator={uiContext.setActivityIndicator}
                            socket={socket}
                            notifyFn={uiContext.notifyFn}
                        />
                    </div>

                    <div className={"row mt-4"}>
                        <OwTitle title={"inventory"} />
                    </div>

                    <div className={"row mb-2"}>
                        <FishbowlConnect
                            supplierModel={supplierModel}
                            userModel={userModel}
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                            isMainViewLight={isMainViewLight}
                        />
                    </div>

                    <div className={"row mb-2"}>
                        <VistaTracConnect
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                            isMainViewLight={isMainViewLight}
                        />
                    </div>

                    {supplierModel.Industries?.some((industry) => industry.name === IndustryNameEnum.Firearms) && (
                        <>
                            <div className={"row mt-4"}>
                                <OwTitle title={"compliance"} />
                            </div>

                            <div className={"row mb-2"}>
                                <FastBoundConnect
                                    socket={socket}
                                    setActivityIndicator={uiContext.setActivityIndicator}
                                    notifyFn={uiContext.notifyFn}
                                    isMainViewLight={isMainViewLight}
                                />
                            </div>
                        </>
                    )}

                    <div className={"row mt-4"}>
                        <OwTitle title={"shipping"} />
                    </div>

                    <div className={"row mb-2"}>
                        <ShipstationConnect
                            supplierModel={supplierModel}
                            userModel={userModel}
                            socket={socket}
                            loadData={loadData}
                            isMainViewLight={isMainViewLight}
                            notifyFn={uiContext.notifyFn}
                        />
                    </div>

                    {/* <div className={"row mb-2"}>
                        <ChRobinsonConnect
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                        />
                    </div> */}

                    <div className={"row mt-4"}>
                        <OwTitle title={"crm"} />
                    </div>

                    <div className={"row mb-2"}>
                        <ZohoConnect socket={socket} reloadSupplierFn={loadData} />
                    </div>

                    <div className={"row mb-2"}>
                        <HubspotConnect
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                        />
                    </div>

                    <div className={"row mt-4"}>
                        <OwTitle title={"other"} />
                    </div>

                    {WineService.isNYSLAEligibleSupplier(supplierModel) && (
                        <div className={"row mb-2"}>
                            <NYSLAConnect
                                supplierModel={supplierModel}
                                userModel={userModel}
                                socket={socket}
                                notifyFn={uiContext.notifyFn}
                                isMainViewLight={isMainViewLight}
                            />
                        </div>
                    )}

                    <div className={"row mb-2"}>
                        <GoogleConnect
                            supplierModel={supplierModel}
                            userModel={userModel}
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                        />
                    </div>

                    <div className={"row mb-2"}>
                        <ZapierConnect />
                    </div>

                    <div className={"row mb-2"}>
                        <SlackConnect
                            supplierModel={supplierModel}
                            userModel={userModel}
                            socket={socket}
                            setActivityIndicator={uiContext.setActivityIndicator}
                            notifyFn={uiContext.notifyFn}
                            isMainViewLight={isMainViewLight}
                        />
                    </div>

                    {/* <div className={"row mb-2"}>
                        <ZoeyConnect socket={socket} setActivityIndicator={uiContext.setActivityIndicator} notifyFn={uiContext.notifyFn} />
                    </div> */}
                </div>
            </div>
        </div>
    );
};
